// extracted by mini-css-extract-plugin
module.exports = {"ChangePasswordWrapper":"ChangePassword_ChangePasswordWrapper__1OQYR","heading":"ChangePassword_heading__1ap44","contents":"ChangePassword_contents__1vPLy"};